"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@ungap/custom-elements");
require("./components/menu/mobile");
require("./components/menu/navigation");
require("./components/video");
require("./styles/core.scss");
